export default "__VITE_ASSET__BFMNauZy__"